import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/list/styles.scss';export default {
  "list": "_list_1nise_1",
  "hovered": "_hovered_1nise_6",
  "unScheduled": "_unScheduled_1nise_9",
  "project": "_project_1nise_9",
  "completed": "_completed_1nise_18"
};